<label class="rounded-radio-container" [class.checked]="checked" [class.disabled]="disabled">
  <mat-radio-group>
    <mat-radio-button color="primary" [value]="value" [disabled]="disabled" [checked]="checked" (change)="onChange()">
      {{ label }}
    </mat-radio-button>
  </mat-radio-group>
  </label>